import React      from 'react';
// import classnames from 'classnames';
import Tooltip    from './Tooltip';
import Label      from './Label';

/*
Show a file component for stencils
 */

class FileComponent extends React.Component {
  constructor(props) {
    super(props);
    this.uploadFile = this.uploadFile.bind(this);

    this.state = {
      fileName: this.props.fileName,
    };
  }

  uploadFile(event) {
    const file = event.target.files[0];
    this.setState({
      fileName: file ? file.name : '',
    });
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  render() {
    // ignore-validate
    // const inputClassName = classnames({
    //   'ignore-validate': !this.props.isFileRequired,
    // }, this.props.inputClassName);

    return (
      <div className="file-input-alt">
        <Label
          label={this.props.label}
          required={this.props.required} >
          <Tooltip
            id={`tooltip-${this.props.name}`}
            title={this.props.tooltip} />
        </Label>

        <div className="input-group">

            <div className="btn btn-primary btn-sm btn-file">
              <span>Browse …</span>
              <input
                id="filename"
                className={this.props.inputClassName}
                name={`${this.props.groupName}[${this.props.name}]`}
                onChange={this.uploadFile}
                type="file" />
            </div>

          <input
            className="form-control file-caption-name"
            onChange={() => (false)}
            value={this.state.fileName} />
        </div>

      </div>
    );
  }
}

FileComponent.defaultProps = {
  name     : 'filename',
  groupName: 'parameters',
  label    : 'FileComponent',
  text     : 'Upload File',
  fileName : 'Select file...',
};

export default FileComponent;
